<script>
    import AdminAccountCreationStatusComponent from './AdminAccountCreationStatusComponent.svelte';
    let statusComponent;
    // form state
    let firstName = '';
    let lastName = '';
    let email = '';
    let studentPhoneNumber = '';
    let parentPhoneNumber = '';
    let grade = '';
    let parentFullName = '';
    let parentEmail = '';
    let specialConditions = {
      'Special Needs': false,
      'IB': false,
      'Lithuanian Second Language': false
    };
  
    // UI state
    let loading = false;
    let error = '';
    let success = '';
  
    async function handleSubmit(event) {
      event.preventDefault();
      error = '';
      success = '';
      loading = true;
  
      // 1️⃣ Get the JWT token
      const token = localStorage.getItem('jwtToken');
      if (!token) {
        error = 'You must be logged in to create a user.';
        loading = false;
        return;
      }
  
      // 2️⃣ Client‐side validation
      if (
        !firstName ||
        !lastName ||
        !email ||
        !studentPhoneNumber ||
        !grade ||
        !parentFullName ||
        !parentEmail
      ) {
        error = 'All required fields must be filled.';
        loading = false;
        return;
      }

      // Validate grade is a number
      if (isNaN(parseInt(grade)) || parseInt(grade) < 1 || parseInt(grade) > 13) {
        error = 'Grade must be a number between 1 and 13.';
        loading = false;
        return;
      }

      // Get selected special conditions
      const selectedConditions = Object.keys(specialConditions).filter(key => specialConditions[key]);
      
      // Validate max 3 conditions
      if (selectedConditions.length > 3) {
        error = 'Please select maximum 3 special conditions.';
        loading = false;
        return;
      }
  
      try {
        // 3️⃣ Send the POST with Authorization header
        const res = await fetch(
          '/studentplayground/api/admin/create_user/',
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({
              username: email, // Use student email as username
              first_name: firstName,
              last_name: lastName,
              email,
              student_phone_number: studentPhoneNumber,
              parent_phone_number: parentPhoneNumber,
              grade: parseInt(grade),
              parent_full_name: parentFullName,
              parent_email: parentEmail,
              special_conditions: selectedConditions
            })
          }
        );
  
        if (!res.ok) {
          const data = await res.json().catch(() => ({}));
          error = data.error || data.detail || 'Failed to create user.';
        } else {
          const data = await res.json().catch(() => ({}));
          success = 'User created successfully! ✔️';
          if (data.user_id) statusComponent?.refreshAndSelect(data.user_id);
          // reset form
          firstName = lastName = email = '';
          studentPhoneNumber = parentPhoneNumber = grade = parentFullName = parentEmail = '';
          specialConditions = {
            'Special Needs': false,
            'IB': false,
            'Lithuanian Second Language': false
          };
        }
      } catch (e) {
        console.error(e);
        error = 'Network error – please try again.';
      } finally {
        loading = false;
      }
    }
  </script>
  
  <div class="labelDiv">
    <span>SUKURTI USERĮ</span>
  </div>
  
  <form on:submit|preventDefault={handleSubmit} class="admin-form">
    <div class="field">
      <label for="firstName">First Name</label>
      <input id="firstName" type="text" bind:value={firstName} required />
    </div>
  
    <div class="field">
      <label for="lastName">Last Name</label>
      <input id="lastName" type="text" bind:value={lastName} required />
    </div>
  
    <div class="field">
      <label for="email">Email</label>
      <div class="input-with-info">
        <input id="email" type="email" bind:value={email} required />
        <div class="info-box">
          <span class="info-text">Bus naudojamas kaip vartotojo vardas</span>
        </div>
      </div>
    </div>

    <div class="field">
      <label for="studentPhoneNumber">Student Phone Number *</label>
      <div class="input-with-info">
        <input id="studentPhoneNumber" type="tel" bind:value={studentPhoneNumber} required />
        <div class="info-box">
          <span class="info-text">Rašyti be +. (Pavyzdys: 37061234567)</span>
        </div>
      </div>
    </div>

    <div class="field">
      <label for="parentPhoneNumber">Parent Phone Number</label>
      <div class="input-with-info">
        <input id="parentPhoneNumber" type="tel" bind:value={parentPhoneNumber} />
        <div class="info-box">
          <span class="info-text">Šitam telefono numeriui bus sunčiamos visos žinutės</span>
        </div>
      </div>
    </div>

    <div class="field">
      <label for="parentFullName">Parent Full Name *</label>
      <input id="parentFullName" type="text" bind:value={parentFullName} required />
    </div>

    <div class="field">
      <label for="parentEmail">Parent Email *</label>
      <div class="input-with-info">
        <input id="parentEmail" type="email" bind:value={parentEmail} required />
        <div class="info-box">
          <span class="info-text">Tėvų el. paštas pranešimams ir informacijai</span>
        </div>
      </div>
    </div>

    <div class="field">
      <label for="grade">Grade *</label>
      <div class="input-with-info">
        <input id="grade" type="number" min="1" max="13" bind:value={grade} required />
        <div class="info-box">
          <span class="info-text">Universiteto lygis = 13</span>
        </div>
      </div>
    </div>

    <div class="field">
      <fieldset class="checkbox-fieldset">
        <legend>Special Conditions (select up to 3)</legend>
        <div class="checkbox-group">
          <div class="checkbox-item">
            <input 
              id="specialNeeds" 
              type="checkbox" 
              bind:checked={specialConditions['Special Needs']}
            />
            <label for="specialNeeds">Special Needs</label>
            <span class="price-indicator">+€3</span>
          </div>
          <div class="checkbox-item">
            <input 
              id="ib" 
              type="checkbox" 
              bind:checked={specialConditions['IB']}
            />
            <label for="ib">IB</label>
            <span class="price-indicator">+€5</span>
          </div>
          <div class="checkbox-item">
            <input 
              id="lithuanianSecondLang" 
              type="checkbox" 
              bind:checked={specialConditions['Lithuanian Second Language']}
            />
            <label for="lithuanianSecondLang">Lithuanian Second Language</label>
            <span class="price-indicator">+€3</span>
          </div>
        </div>
      </fieldset>
    </div>
  
    <button type="submit" class="btn" disabled={loading}>
      {#if loading}
        Creating…
      {:else}
        Create User
      {/if}
    </button>
  
    {#if error}
      <p class="error">{error}</p>
    {/if}
  
    {#if success}
      <p class="success">{success}</p>
    {/if}
  </form>
  <AdminAccountCreationStatusComponent bind:this={statusComponent} />
  
  <style>
    .labelDiv {
      display: flex;
      justify-content: space-around;
    }
    .field {
      display: flex;
      flex-direction: column;
      margin-bottom: 1rem;
      width: 100%;
    }
    .field label {
      font-weight: bold;
      margin-bottom: 0.4rem;
    }
    .field input {
      padding: 0.5rem;
      border: 1px solid #ccc;
      border-radius: 4px;
      font-size: 1rem;
      width: 100%;
    }
    
    /* Smaller width for specific fields */
    #studentPhoneNumber,
    #parentPhoneNumber {
      max-width: 167px;
    }
    
    
    #grade {
      max-width: 80px;
    }
    .checkbox-fieldset {
      border: 1px solid #ccc;
      border-radius: 4px;
      padding: 0.8rem;
      margin: 0;
    }
    .checkbox-fieldset legend {
      font-weight: bold;
      padding: 0 0.5rem;
      margin-bottom: 0.5rem;
    }
    .checkbox-group {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
    }
    .checkbox-item {
      display: flex;
      align-items: center;
      gap: 0.5rem;
    }
    .checkbox-item input[type="checkbox"] {
      width: auto;
      margin: 0;
    }
    .checkbox-item label {
      margin: 0;
      font-weight: normal;
      cursor: pointer;
      flex: 1;
    }
    .price-indicator {
      color: #007acc;
      font-weight: bold;
      font-size: 0.9rem;
      background-color: #e8f4fd;
      padding: 0.2rem 0.5rem;
      border-radius: 12px;
      border: 1px solid #b3d9f2;
      margin-left: 0.5rem;
      white-space: nowrap;
    }
    .input-with-info {
      position: relative;
    }
    .info-box {
      margin-top: 0.3rem;
      padding: 0.4rem;
      background-color: #f0f8ff;
      border: 1px solid #b0d4f1;
      border-radius: 4px;
      font-size: 0.85rem;
    }
    .info-text {
      color: #2c5aa0;
      font-style: italic;
    }
    .btn {
      display: inline-block;
      padding: 0.6rem 1rem;
      background-color: #0055aa;
      color: #fff;
      border: none;
      border-radius: 4px;
      cursor: pointer;
      font-size: 1rem;
      margin-top: 0.5rem;
    }
    .btn:hover {
      background-color: #004488;
    }
    .btn:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
    .error {
      color: #cc0000;
      margin-top: 0.8rem;
    }
    .success {
      color: #006600;
      margin-top: 0.8rem;
    }
  </style>
